<button class="btn" [ngClass]="{'btn-xs': size === 'xs', 'btn-sm': size !== 'xs', 'btn-primary': buttonText === 'Import', 'btn-secondary': buttonText !== 'Import'}" [disabled]="!games || !games.length" (click)="onButtonClick($event)" title="Quick Edit">
    <i class="fa fa-download"></i> {{ buttonText }}
</button>

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Import Games</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div *ngIf="!importDone">
        <p>
          The following Games will be imported to Hexagon
        </p>
        <ul>
          <li *ngFor="let game of games">{{ game.name }}</li>
        </ul>
      </div>

      <div *ngIf="importDone && importedGames.length > 0">
        <p>
          Games were successfully imported!
        </p>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Media order</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let game of importedGames">
              <td><a href="/new_cdb/games/{{ game.game_id }}" target="_blank">{{ game.name }}</a></td>
              <td>
                <span *ngIf="game.media_order_status === 'creating'"><i class="fa fa-fw fa-refresh fa-spin"></i> Creating media order...</span>
                <span *ngIf="game.media_order_status === 'created'"><i class="fa fa-fw fa-check text-success"></i> Created (<a href="/new_cdb/games/{{ game.game_id }}/media?open_media_order={{ game.media_order_id }}" target="_blank">#{{ game.media_order_id }}</a>)</span>
                <span *ngIf="game.media_order_status === 'failed'" class="text-danger"><i class="fa fa-fw fa-times"></i> Failed to create media order</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="alreadyExistingGames.length > 0">
        <p>
          The following Games already exist in Hexagon and were not imported again (marked as imported):
        </p>
        <ul>
          <li *ngFor="let game of alreadyExistingGames">
            <a href="/new_cdb/games/{{ game.game_id }}" target="_blank">{{ game.name }}</a> (ID: {{ game.game_id }})
          </li>
        </ul>
      </div>

      <div *ngIf="notFoundManufacturers.length > 0">
        <p>
          The following Manufacturers could not be found in Cdb
        </p>
        <ul>
          <li *ngFor="let row of notFoundManufacturers">
            {{ row }}
          </li>
        </ul>
      </div>

      <div *ngIf="importDone && importedGames.length === 0 && alreadyExistingGames.length === 0">
        <p>
          Nothing was imported - the selected games have already been imported.
        </p>
      </div>

      <div class="text-end">
        <button *ngIf="!importDone" type="button" class="btn btn-primary m-5" [disabled]="isSaving" (click)="onSave()">Save</button>
        <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
      </div>
        
    </div>
</ng-template>